import { Field } from 'formik'
import cn from 'classnames'

import ToggleWithLabel from 'components/ToggleWithLabel'

import { TIP_CONFIGURATIONS_SETTINGS } from 'resources'

const TipConfigurations = ({
  header,
  isShowVenueSettingsMessage,
  handleChecked,
  handleChange,
  handleSetName,
  classNames,
}) => {
  return (
    <section
      className={cn(
        'content-wrapper -block -flags-wrapper',
        classNames
      )}
      data-error="standsSettings"
    >
      <h3 className="header-title -margin-bottom-xxs">{header}</h3>
      <span className="description">
        Editing Tip Configurations on the Revenue Center will override
        Venue Settings.
      </span>
      {isShowVenueSettingsMessage && (
        <p className="description -color-danger">
          Tip Configurations have been added in Venue Settings.
        </p>
      )}
      {TIP_CONFIGURATIONS_SETTINGS?.map(
        ({ name, title, description }) => {
          return (
            <div className="content-wrapper -block" key={name}>
              <Field
                component={ToggleWithLabel}
                checked={handleChecked(name)}
                label={title}
                onChange={(e) => handleChange(e.target.checked, name)}
                name={handleSetName(name)}
                dataCy={name}
              />
              <span className="description">{description}</span>
            </div>
          )
        }
      )}
    </section>
  )
}

export default TipConfigurations
